import React, {useRef} from 'react';
import Form, {FormInputComponent} from "../../../components/form/Form";
import {Button, Input} from "antd";
import {EditFilled} from "@ant-design/icons";
import {useTalentTeam} from "../../../providers/TalentTeamProvider";
import ReactDOM from "react-dom";

const TeamNameForm = ({isEditing, onToggleEdit,...props}) => {

    const inputRef = useRef(null);
    const formRef = useRef(null);

    // const {auth, appropriate, logout} = useAuth();

    // const [isEditing, setIsEditing] = useState(false);

    const {
        team,
        isLoading,
        updateTeamDetails,
        createTeam,
        isUpdating,
        onModelChange,
        resetModel
    } = useTalentTeam();

    const onCancelEdit = async () => {
        if (!isUpdating) {
            await resetModel()
            return onToggleEdit(false);
        }
    }

    const onSubmitEdit = async () => {

        if (formRef?.current) {
            let invalid = formRef.current.forceValidate();

            if (invalid) {
                const node = ReactDOM.findDOMNode(invalid);
                return $('html, body').animate({scrollTop: $(node).offset().top - 50}, 800);
            }
        }
        const didUpdate = await updateTeamDetails(team)
        if (didUpdate) {
            return onToggleEdit(false);
        } else {
            return onCancelEdit();
        }
    }
    return (
        <div className="team-name-form">
            <Form
                ref={formRef}
                background="transparent"
                minimal
                title={null}
                subtitle={null}
                showRequired
                submitButton={false}
                onChange={(model) => onModelChange({...team, ...model})}
                model={team}
                fields={[]}
                isDisabled={false}>

                <div className="flex flex-row items-center gap-2">

                    <div className="mb-4 mr-2 flex flex-row items-center">
                        <p className="font-semibold">
                            Team Name
                        </p>
                    </div>
                    <div className={TB.mapClass("field px-0", {
                        "basis-6/12": isEditing,
                        "border-0 basis-6/12 pointer-events-none": !isEditing
                    })}>
                        <FormInputComponent
                            fieldName="name"
                            type="antd-input"
                            label={false}
                            value={team?.name || ""}
                            minLength={5}
                            maxLength={50}
                            required={true}
                            placeholder="Enter name here..."
                            validation={{
                                rules: {
                                    maxLength: 50,
                                    minLength: 5
                                },
                                errors: {
                                    maxLength: TB.trans('validation.max.string', {
                                        'attribute': 'Team Name',
                                        'max': 50
                                    }),
                                    minLength: TB.trans('validation.min.string', {
                                        'attribute': 'Team Name',
                                        'min': 5
                                    })
                                }
                            }}>
                            <Input
                                ref={inputRef}
                                className={TB.mapClass("", {
                                    // "basis-6/12": isEditing,
                                    "border-0": !isEditing
                                })}
                                maxLength={50}
                                disabled={isUpdating} readOnly={!isEditing}/>

                        </FormInputComponent>
                    </div>


                    {isEditing ? (
                        <div className="flex gap-3">
                            <button className="btn btn-outline-white mb-4 py-[5px] border-0"
                                    onClick={onCancelEdit}
                                    disabled={isUpdating || props.isDisabled}>
                                Cancel
                            </button>
                            <button className="btn btn-primary mb-4 py-[5px] border-0"
                                    onClick={onSubmitEdit}
                                    disabled={isUpdating || props.isDisabled}>
                                Update
                            </button>
                        </div>
                    ) : (
                        <Button type="text"
                                className="mb-4 text-info px-1"
                                onClick={async () => {
                                    await onToggleEdit(true);
                                    return inputRef.current?.focus({
                                        cursor: 'end',
                                    });
                                }}
                                disabled={isUpdating || props.isDisabled}>
                            <EditFilled style={{fontSize: 15}}/>
                            Edit
                        </Button>
                    )}

                </div>
            </Form></div>
    )
};

export default TeamNameForm;